import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommFormList extends Layout {
    layoutheaderTitle: LayoutHeader;
    sourceMCForm: DataSource;
    tableMCForm: Table;
}
